import { useEffect, useState } from 'react'
import { activeIcon } from '../../utils';
import { MATCH_COLOR, PARAMETER_EVENT, TEXT_COLOR_ELEMENTS, TITLE_COLOR_ELEMENTS, WIDGET_CLASS_ATTRIBUTES } from '../../utils/constants';

const useColorAdjustment = () => {

  let html = document.getElementsByTagName("html")[0];

  // TEXT COLOR //
  const [colorAdjutment, setColorAdjutment] = useState({ color: "", rgbaColor: "", isActive: false });

  //  TITLE COLOR  //
  const [colorTitleAdjustment, setColorTitleAdjustment] = useState({ rcpTitleColor: "", rgbaColor: "", isActivetitleColor: false });

  //  BACKGROUND COLOR  //
  const [backgroundColorAdjustment, setBackgroundColorAdjustment] = useState({ rcpBgColor: "", rgbaColor: "", isActiveBackgroundColor: false });


  useEffect(() => {
    //  TEXT COLOR  //
    let tag = document.querySelectorAll(TEXT_COLOR_ELEMENTS);
    let coloText = localStorage.getItem("rcpTextColor");
    if (colorAdjutment.color && colorAdjutment?.color?.length > 0 && coloText && coloText.length > 0) {
      localStorage.setItem("rcpColorState", JSON.stringify(colorAdjutment));

      let getColorClass = document.querySelector(`.rcpTextColorClass.${colorAdjutment.color}`);
      if (getColorClass) {
        getColorClass.classList.add("rcpWidgetCircle");
      }
      for (let i = 0; i < tag.length; i++) { applyStyles(tag[i], colorAdjutment?.rgbaColor) }
      activeIcon(PARAMETER_EVENT.BLOCK);
    }

    //  TITLE COLOR  //
    let colorTitle = localStorage.getItem("rcpTitleColor");
    let tagtitleColor = document.querySelectorAll("body h1:not(#progatixWidget h1),body h2:not(#progatixWidget h2),body h3:not(#progatixWidget h3),body h4:not(#progatixWidget h4),body h5:not(#progatixWidget h5),body h6:not(#progatixWidget h6),body th:not(#progatixWidget th)");
    if (colorTitleAdjustment.rcpTitleColor && colorTitleAdjustment.rcpTitleColor.length > 0 && colorTitle && colorTitle.length > 0) {
      localStorage.setItem("rcpTitleColorState", JSON.stringify(colorTitleAdjustment));

      let getTitleColorClass = document.querySelector(`.rcpTitleColorClass.${colorTitleAdjustment.rcpTitleColor}`);
      if (getTitleColorClass) {
        getTitleColorClass.classList.add("rcpWidgetCircle");
      }

      for (let i = 0; i < tagtitleColor.length; i++) {
        for (let j = 0; j < tagtitleColor[i].children.length; j++) { applyStyles(tagtitleColor[i].children[j], colorTitleAdjustment?.rgbaColor); }
        applyStyles(tagtitleColor[i], colorTitleAdjustment?.rgbaColor);
      }
      activeIcon(PARAMETER_EVENT.BLOCK)
    }

    //  BACKGROUND COLOR   //
    let colorBackground = localStorage.getItem("rcpBgColor");
    let getTargetTags = document.querySelectorAll("body:not(#progatixWidget),body section:not(#progatixWidget section),body main:not(#progatixWidget main),body header:not(#progatixWidget header),body nav:not(#progatixWidget nav),body footer:not(#progatixWidget footer),body form:not(#progatixWidget form)");
    if (backgroundColorAdjustment.rcpBgColor && backgroundColorAdjustment.rcpBgColor.length > 0 && colorBackground && colorBackground.length > 0) {
      localStorage.setItem("rcpBgColorState", JSON.stringify(backgroundColorAdjustment));

      let getBackgroundColorClass = document.querySelector(`.rcpBgColorClass.${backgroundColorAdjustment.rcpBgColor}`);
      if (getBackgroundColorClass) {
        getBackgroundColorClass.classList.add("rcpWidgetCircle");
      }

      html.classList.add("rcpInjectBackgroundColorClass");
      window.document.body.style.backgroundColor = `${backgroundColorAdjustment.rgbaColor}`;
      for (let i = 0; i < getTargetTags.length; i++) {
        let getAttri = getTargetTags[i].getAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_STYLE);
        let newStyle =
          getAttri === null
            ? `background-color: ${backgroundColorAdjustment.rgbaColor} !important;`
            : `${getAttri}; background-color: ${backgroundColorAdjustment.rgbaColor} !important;`;
        getTargetTags[i].setAttribute("style", newStyle);
      }
      activeIcon(PARAMETER_EVENT.BLOCK)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorAdjutment, colorTitleAdjustment, backgroundColorAdjustment]);

  //  DARK CONTRAST  //
  function darkContrast(CheckMark) {
    let isBoxId = document.querySelector("#darkContrast");

    const applyDarkContrast = () => {
      [lightContrast, highContrast, highSaturation, lowSaturation, monoChromeSaturation].forEach(func => func(PARAMETER_EVENT.REMOVE));
      html.classList.add("rcpDarkContrast");
      isBoxId.classList.add("rcpEnableFeature");
      localStorage.setItem("rcp-dark-contrast", PARAMETER_EVENT.OPEN);
      activeIcon(PARAMETER_EVENT.BLOCK);
    };

    const removeDarkContrast = () => {
      html.classList.remove("rcpDarkContrast");
      isBoxId.classList.remove("rcpEnableFeature");
      localStorage.removeItem("rcp-dark-contrast");
      activeIcon(PARAMETER_EVENT.NONE);
    };

    if (CheckMark === PARAMETER_EVENT.TOGGLE) {
      (html.classList.contains("rcpDarkContrast") && isBoxId.classList.contains("rcpEnableFeature")) ? removeDarkContrast() : applyDarkContrast();
    } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
      applyDarkContrast()
    } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
      removeDarkContrast()
    }
  }

  //  LIGHT CONTRAST //
  function lightContrast(CheckMark) {
    let isBoxId = document.querySelector("#lightContrast");

    function removeLightContrast() {
      html.classList.remove("rcpLightContrast");
      isBoxId.classList.remove("rcpEnableFeature");
      localStorage.removeItem("rcp-light-contrast");
      activeIcon(PARAMETER_EVENT.NONE);
    }

    function applyLightContrast() {
      [darkContrast, highContrast, highSaturation, lowSaturation, monoChromeSaturation].forEach(func => func(PARAMETER_EVENT.REMOVE));
      html.classList.add("rcpLightContrast")
      isBoxId.classList.add("rcpEnableFeature");
      localStorage.setItem("rcp-light-contrast", PARAMETER_EVENT.OPEN);
      activeIcon(PARAMETER_EVENT.BLOCK);
    }

    if (CheckMark === PARAMETER_EVENT.TOGGLE) {
      (html.classList.contains("rcpLightContrast") && isBoxId.classList.contains("rcpEnableFeature")) ? removeLightContrast() : applyLightContrast();
    } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
      applyLightContrast()
    } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
      removeLightContrast();
    }

  }

  //  HIGHT CONTRAST  //
  function highContrast(CheckMark) {
    let isBoxId = document.querySelector("#highContrast");

    function removeHighContrast() {
      html.classList.remove("rcpLhighContrast");
      isBoxId.classList.remove("rcpEnableFeature");
      localStorage.removeItem("rcp-high-contrast");
      activeIcon(PARAMETER_EVENT.NONE);
    }

    function applyHighContrast() {
      [darkContrast, lightContrast, highSaturation, lowSaturation, monoChromeSaturation].forEach(func => func(PARAMETER_EVENT.REMOVE));
      html.classList.add("rcpLhighContrast");
      isBoxId.classList.add("rcpEnableFeature");
      localStorage.setItem("rcp-high-contrast", PARAMETER_EVENT.OPEN);
      activeIcon(PARAMETER_EVENT.BLOCK);
    }

    if (CheckMark === PARAMETER_EVENT.TOGGLE) {
      (html.classList.contains("rcpLhighContrast") && isBoxId.classList.contains("rcpEnableFeature")) ? removeHighContrast() : applyHighContrast();
    } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
      applyHighContrast();
    } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
      removeHighContrast();
    }
  }

  //  HIGHT SATURATION  //
  function highSaturation(CheckMark) {
    let isBoxId = document.querySelector("#saturationHight");

    function removeHighSaturation() {
      html.classList.remove("rcpHighSaturation");
      isBoxId.classList.remove("rcpEnableFeature");
      localStorage.removeItem("rcp-high-saturation");
      activeIcon(PARAMETER_EVENT.NONE);
    }

    function applyHighSaturation() {
      [darkContrast, highContrast, lightContrast, lowSaturation, monoChromeSaturation].forEach(func => func(PARAMETER_EVENT.REMOVE));
      html.classList.add("rcpHighSaturation");
      isBoxId.classList.add("rcpEnableFeature");
      localStorage.setItem("rcp-high-saturation", PARAMETER_EVENT.OPEN);
      activeIcon(PARAMETER_EVENT.BLOCK);
    }

    if (CheckMark === PARAMETER_EVENT.TOGGLE) {
      (html.classList.contains("rcpHighSaturation") && isBoxId.classList.contains("rcpEnableFeature")) ? removeHighSaturation() : applyHighSaturation();
    } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
      applyHighSaturation();
    } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
      removeHighSaturation();
    }
  }

  //  LOW SATURATION  //
  function lowSaturation(CheckMark) {
    let isBoxId = document.querySelector("#saturationLow");

    function removeLowSaturation() {
      html.classList.remove("rcpLowSaturation");
      isBoxId.classList.remove("rcpEnableFeature");
      localStorage.removeItem("rcp-low-saturation");
      activeIcon(PARAMETER_EVENT.NONE);
    }

    function applyLowSaturation() {
      [darkContrast, highContrast, highSaturation, lightContrast, monoChromeSaturation].forEach(func => func(PARAMETER_EVENT.REMOVE));
      html.classList.add("rcpLowSaturation");
      isBoxId.classList.add("rcpEnableFeature");
      localStorage.setItem("rcp-low-saturation", PARAMETER_EVENT.OPEN);
      activeIcon(PARAMETER_EVENT.BLOCK);
    }

    if (CheckMark === PARAMETER_EVENT.TOGGLE) {
      (html.classList.contains("rcpLowSaturation") && isBoxId.classList.contains("rcpEnableFeature")) ? removeLowSaturation() : applyLowSaturation();
    } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
      applyLowSaturation();
    } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
      removeLowSaturation();
    }
  }

  //  MONOCHOROME SATURATION  //
  function monoChromeSaturation(CheckMark) {
    let isBoxId = document.querySelector("#saturationMonoChrome");

    function removeMonoChromeSaturation() {
      html.classList.remove("rcpMonoChromeSaturation");
      isBoxId.classList.remove("rcpEnableFeature");
      localStorage.removeItem("rcp-monoChrome-saturation");
      activeIcon(PARAMETER_EVENT.NONE);
    }

    function applyMonoChromeSaturation() {
      [darkContrast, highContrast, highSaturation, lightContrast, lowSaturation].forEach(func => func(PARAMETER_EVENT.REMOVE));
      html.classList.add("rcpMonoChromeSaturation");
      isBoxId.classList.add("rcpEnableFeature");
      localStorage.setItem("rcp-monoChrome-saturation", PARAMETER_EVENT.OPEN);
      activeIcon(PARAMETER_EVENT.BLOCK);
    }

    if (CheckMark === PARAMETER_EVENT.TOGGLE) {
      (html.classList.contains("rcpMonoChromeSaturation") && isBoxId.classList.contains("rcpEnableFeature")) ? removeMonoChromeSaturation() : applyMonoChromeSaturation();
    } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
      applyMonoChromeSaturation();
    } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
      removeMonoChromeSaturation();
    }
  }

  //  TEXT COLOR  //

  const clearStyles = (element) => {
    let getAttri = element.getAttribute("style");
    if (getAttri && getAttri.includes("color")) {
      const currentColorMatch = getAttri.match(/color:\s*([^;]*);/);
      if (currentColorMatch) {
        const currentColor = currentColorMatch[1].trim();
        const isMatch = MATCH_COLOR.find((f) => currentColor.includes(f.toLowerCase()));
        if (isMatch) {
          const newStyle = getAttri.replace(/color:\s*[^;]*;/g, '');
          element.setAttribute("style", newStyle);
        }
        let defaultColor = element.getAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_STYLE);
        if (defaultColor) {
          const colorMatch = defaultColor.match(/color:\s*([^;]*);/);
          if (colorMatch) {
            const colorValue = colorMatch[1].trim();
            element.setAttribute("style", `color:${colorValue};`);
          }
        }
      }
    }
  };

  const applyStyles = (element, rgbaColor) => {
    let getAttri = element.getAttribute("style");
    let newStyle;
    if (getAttri === null) {
      newStyle = `color: ${rgbaColor} !important;`;
    } else if (getAttri.includes("color")) {
      newStyle = getAttri.replace(/color:\s*[^;]*;/g, `color: ${rgbaColor} !important;`);
    } else {
      newStyle = `${getAttri}; color: ${rgbaColor} !important;`;
    }
    element.setAttribute("style", newStyle);
  };

  const handleTextColor = (color, rgbaColor) => {
    let tag = document.querySelectorAll(TEXT_COLOR_ELEMENTS);
    if (tag[0].style.color !== color) {
      setColorAdjutment({ color: color, rgbaColor: rgbaColor, isActive: true });
    }
    let eleColor = document.querySelector(`.rcpTextColorClass.rcpWidgetCircle`);
    if (eleColor) {
      eleColor?.classList?.remove("rcpWidgetCircle");
    }
    // on cancel
    if (color === "") {
      localStorage.removeItem("rcpColorState");
      localStorage.removeItem("rcpTextColor");
      setColorAdjutment({ color: "", rgbaColor: "", isActive: false });
      for (let i = 0; i < tag.length; i++) { clearStyles(tag[i]) }
      activeIcon(PARAMETER_EVENT.NONE)
    }

    if (colorAdjutment.isActive) {
      let getColorClass = document.querySelector(`.rcpTextColorClass${color}`);
      if (getColorClass && color !== "") {
        getColorClass.classList.add("rcpWidgetCircle");
      }
    }
    if (eleColor) {
      eleColor?.classList?.remove("rcpWidgetCircle");
    }
    // on uncheck
    if (tag[0].style.color === rgbaColor) {
      for (let i = 0; i < tag.length; i++) { clearStyles(tag[i]) }
      setColorAdjutment({ color: "", rgbaColor: "", isActive: false });
      eleColor?.classList?.remove("rcpWidgetCircle");
      activeIcon(PARAMETER_EVENT.NONE);
      localStorage.removeItem("rcpColorState");
      localStorage.removeItem("rcpTextColor");
    } else {
      for (let i = 0; i < tag.length; i++) { applyStyles(tag[i], rgbaColor) }
      activeIcon(PARAMETER_EVENT.BLOCK)
      localStorage.setItem("rcpTextColor", color);
    }
  };

  //  TITLE COLOR  //
  const handletitleColor = (rcpTitleColor, rgbaColor) => {
    let tagtitleColor = document.querySelectorAll(TITLE_COLOR_ELEMENTS);
    if (tagtitleColor[0].style.color !== rcpTitleColor) {
      setColorTitleAdjustment({ rcpTitleColor: rcpTitleColor, rgbaColor: rgbaColor, isActivetitleColor: true });
    }
    let eletitleColor = document.querySelector(`.rcpTitleColorClass.rcpWidgetCircle`);
    if (eletitleColor) {
      eletitleColor.classList.remove("rcpWidgetCircle");
    }
    // on cancel
    if (rcpTitleColor === "") {
      localStorage.removeItem("rcpTitleColorState");
      localStorage.removeItem("rcpTitleColor");
      for (let i = 0; i < tagtitleColor.length; i++) { clearStyles(tagtitleColor[i]) }
      activeIcon(PARAMETER_EVENT.NONE);
    }
    // on cancel
    if (colorTitleAdjustment.isActivetitleColor) {
      let getTitleColorClass = document.querySelector(`.rcpTitleColorClass${rcpTitleColor} `);
      if (getTitleColorClass && rcpTitleColor !== "") {
        getTitleColorClass.classList.add("rcpWidgetCircle");
      }
    }
    if (eletitleColor) {
      eletitleColor.classList.remove("rcpWidgetCircle");
    }

    if (tagtitleColor[0].style.color === rgbaColor) {
      for (let i = 0; i < tagtitleColor.length; i++) {
        for (let j = 0; j < tagtitleColor[i].children.length; j++) { clearStyles(tagtitleColor[i].children[j]) }
        clearStyles(tagtitleColor[i]);
      }
      setColorTitleAdjustment({ rcpTitleColor: "", rgbaColor: "", isActivetitleColor: false });
      activeIcon(PARAMETER_EVENT.NONE)
      localStorage.removeItem("rcpTitleColorState");
      localStorage.removeItem("rcpTitleColor");
    } else {
      for (let i = 0; i < tagtitleColor.length; i++) {
        for (let j = 0; j < tagtitleColor[i].children.length; j++) { applyStyles(tagtitleColor[i].children[j], rgbaColor) }
        applyStyles(tagtitleColor[i], rgbaColor);
      }
      activeIcon(PARAMETER_EVENT.BLOCK);
      localStorage.setItem("rcpTitleColor", rcpTitleColor);
    }
  };

  //  BACKGROUND COLOR  //
  const handleBackgrondColor = (rcpBgColor, rgbaColor) => {
    if (window.document.body.style.backgroundColor !== rcpBgColor) {
      setBackgroundColorAdjustment({ rcpBgColor: rcpBgColor, rgbaColor: rgbaColor, isActiveBackgroundColor: true, });
    }
    let eleBackgroundColor = document.querySelector(`.rcpBgColorClass.rcpWidgetCircle`);
    if (eleBackgroundColor) {
      eleBackgroundColor.classList.remove("rcpWidgetCircle");
    }
    // on cancel
    if (rcpBgColor === "") {
      localStorage.removeItem("rcpBgColorState");
      localStorage.removeItem("rcpBgColor");
      window.document.body.style.backgroundColor = "";
      activeIcon(PARAMETER_EVENT.NONE);
    }
    // on cancel

    if (backgroundColorAdjustment.isActiveBackgroundColor) {
      let getBackgroundColorClass = document.body.querySelector(`.rcpBgColorClass${rcpBgColor}`);
      if (getBackgroundColorClass && rcpBgColor !== "") {
        getBackgroundColorClass.classList.add("rcpWidgetCircle");
      }
    }
    if (eleBackgroundColor) {
      eleBackgroundColor.classList.remove("rcpWidgetCircle");
    }

    let getTargetTags = document.querySelectorAll("body:not(#progatixWidget),body section:not(#progatixWidget section),body main:not(#progatixWidget main),body header:not(#progatixWidget header),body nav:not(#progatixWidget nav),body footer:not(#progatixWidget footer),body form:not(#progatixWidget form)");

    if (window.document.body.style.backgroundColor === rgbaColor) {
      html.classList.remove("rcpInjectBackgroundColorClass");
      window.document.body.style.backgroundColor = "";
      localStorage.removeItem("rcpBgColor");
      localStorage.removeItem("rcpBgColorState");
      activeIcon(PARAMETER_EVENT.NONE)
      for (let i = 0; i < getTargetTags.length; i++) {
        let getAttri = getTargetTags[i].getAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_STYLE);
        let newStyle = getAttri === null ? `` : `${getAttri}`;
        getTargetTags[i].setAttribute("style", newStyle);
      }
    } else {
      html.classList.add("rcpInjectBackgroundColorClass");
      window.document.body.style.backgroundColor = `${rgbaColor}`;
      for (let i = 0; i < getTargetTags.length; i++) {
        let getAttri = getTargetTags[i].getAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_STYLE);
        let newStyle =
          getAttri === null
            ? `background-color: ${rgbaColor} !important;`
            : `${getAttri}; background-color: ${rgbaColor} !important;`;
        getTargetTags[i].setAttribute("style", newStyle);
      }
      activeIcon(PARAMETER_EVENT.BLOCK);
      localStorage.setItem("rcpBgColor", rcpBgColor);
    }
  };



  return { darkContrast, lightContrast, highContrast, highSaturation, lowSaturation, monoChromeSaturation, handleTextColor, setColorAdjutment, handletitleColor, setColorTitleAdjustment, handleBackgrondColor, setBackgroundColorAdjustment, colorAdjutment, colorTitleAdjustment }
}

export default useColorAdjustment